import { render, staticRenderFns } from "./pie-revenue-segment.vue?vue&type=template&id=2478b944&scoped=true&"
import script from "./pie-revenue-segment.vue?vue&type=script&lang=js&"
export * from "./pie-revenue-segment.vue?vue&type=script&lang=js&"
import style0 from "./pie-revenue-segment.vue?vue&type=style&index=0&id=2478b944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478b944",
  null
  
)

export default component.exports